import { render, staticRenderFns } from "./TablePatient.vue?vue&type=template&id=10c0c25d&scoped=true&"
import script from "./TablePatient.vue?vue&type=script&lang=js&"
export * from "./TablePatient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c0c25d",
  null
  
)

export default component.exports